var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPercentTvaColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26.3334927px",
    height: "33.0025221px",
    viewBox: "0 0 26.3334927 33.0025221",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_percent_tva_color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gestionnaire---Param\\xE8tres",
    transform: "translate(-82.833174, -552.500000)",
    stroke: "#AFBC9D",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(40.000000, 521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_percent_tva_color",
    transform: "translate(44.333333, 33.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.66666667,
    y1: 18.3333333,
    x2: 16.6666667,
    y2: 8.33333333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#AFBC9D",
    fillRule: "nonzero",
    cx: 7.5,
    cy: 9.16666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#AFBC9D",
    fillRule: "nonzero",
    cx: 15.8333333,
    cy: 17.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,30 L0,3.33333333 C0,1.49238417 1.49238417,0 3.33333333,0 L20,0 C21.8409492,0 23.3333333,1.49238417 23.3333333,3.33333333 L23.3333333,30 L18.3333333,26.6666667 L15,30 L11.6666667,26.6666667 L8.33333333,30 L5,26.6666667 L0,30",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPercentTvaColor);
export default __webpack_public_path__ + "static/media/icon_percent_tva_color.35ffce669bc814fcc69805e0a8d182bb.svg";
export { ForwardRef as ReactComponent };